import React, { useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import SubmitButton from '../../../components/form/SubmitButton';
import { useLocation, useNavigate } from 'react-router-dom';
import LoadingButton from '../../../components/form/LoadingButton';
import { apiPost } from '../../../utils/api';
import { showError, showSuccess } from '../../../utils/alert';
import { useDispatch } from 'react-redux';
import { loginCustomer } from '../../../redux/customerSlice';
import { getdeviceId } from '../../../utils/auth';

export default function CustomerVerifyOtp() {
    const location = useLocation();
  const { phone, redirect } = (location.state as { phone?: string; redirect?: string }) || {}; // 👈 أضف redirect
  const { t } = useTranslation();
  const { handleSubmit } = useForm();
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (value: string, index: number) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Auto move to next input
      if (value && index < 3) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const onSubmit = async () => {
    try {
      const code = otp.join("");
      if (code.length < 4) {
        showError(t("otp_required") || "Please enter full OTP");
        return;
      }

      setLoading(true);
      const deviceId = getdeviceId();
      const response = await apiPost('otp-code/verify/customer', { code ,phone,deviceId}) as { status: string ,refreshToken:string,accessToken:string};
      const message = response.status === "login" ? t("signin_opt") : t("signup_account");
      showSuccess(message);
      dispatch(loginCustomer({refreshToken:response.refreshToken,accessToken:response.accessToken}));

      if (response.status === "login") {
        navigate(redirect || "/customer/delete-account", { replace: true });
      } 
      else{
        showError(t('invalid_phone'))
      }
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      showError(err.message);
    }
  };

  return (
    <div className="min-h-screen w-screen flex flex-col md:flex-row bg-light overflow-hidden">
      {/* Image Section */}
      <div className="hidden md:block md:w-1/2 h-screen">
        <img
          src={"/main.png"}
          alt="Login"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Form Section */}
      <div className="flex flex-1 justify-center items-center p-8 md:p-16 min-h-screen">
        <div className="w-full max-w-md p-6 md:p-8">
          {/* Title */}
          <h1 className="text-2xl text-center font-bold text-Black mb-2">{t('otp_verify')}</h1>
          <p className="text-Black font-normal text-center mb-1">{t('otp_sent')}</p>
          <p className=' text-center text-Black font-semibold mb-5'>+{phone}</p>

          {/* OTP Form */}
          <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-6" dir='ltr'>
            <div className="flex justify-center gap-3">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={(el: HTMLInputElement | null) => {
                    inputRefs.current[index] = el;
                    }}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleChange(e.target.value, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  className="w-14 h-14 text-center text-xl border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                />
              ))}
            </div>

            {
              loading
                ? <LoadingButton height={64} />
                : <SubmitButton height={64} label={t('verify_otp') || "Verify OTP"} />
            }
          </form>
        </div>
      </div>
    </div>
  );
}
